import { render } from "./PassTypeIcon.vue?vue&type=template&id=42e9bb46"
import script from "./PassTypeIcon.vue?vue&type=script&lang=js"
export * from "./PassTypeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__